import { type FC, memo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getHeaderMenuIcon, type Menus } from 'src/routers/menu';
import styles from './menu-children.module.scss';

interface OwnProps {
  menu: Menus;
  onChangeVisible(value: boolean): void;
}

const MenuChildren: FC<OwnProps> = ({ menu, onChangeVisible }) => {
  const navigate = useNavigate();
  const touchEvent = (path: string) => {
    navigate(path);
  };
  return (
    <div className={`${styles.items} ${styles.items_mobile}`} onClick={(e) => e.stopPropagation()}>
      {menu.children?.map((item) => {
        const external = item.path.indexOf('http') === 0;
        const isActive = location.pathname.indexOf(item.path) === 0;
        const $img = (
          <img src={getHeaderMenuIcon(item.key + (isActive ? '-active' : ''))} data-icon />
        );

        if (external || item.target === '_blank') {
          return (
            <Link
              to={item.path}
              key={item.key}
              target={item.target || '_self'}
              onClick={() => onChangeVisible(false)}
            >
              {$img}
              <span>{item.name}</span>
            </Link>
          );
        }

        return (
          <Link
            to={item.path}
            key={item.key}
            onClick={() => onChangeVisible(false)}
            onTouchStart={() => touchEvent(item.path)}
          >
            {$img}
            <span>{item.name}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default memo(MenuChildren);
